import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { BitbucketConfigurationTab } from "./BitbucketConfigurationTab"
import { BitbucketConnectTab } from "./BitbucketConnectTab"

export const BitbucketConfigurationPage = () => (
  <ConfigurationPageTemplate
    vendor={INTEGRATION_VENDORS.bitbucket}
    connect={<BitbucketConnectTab vendor={INTEGRATION_VENDORS.bitbucket} />}
    config={
      <BitbucketConfigurationTab vendor={INTEGRATION_VENDORS.bitbucket} />
    }
    titleKey="integrations.configuration.Bitbucket.configurationTitle"
  />
)
